var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAbsent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#171717",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0718 17.5026L23.8418 12.7326C24.2758 12.2986 24.2758 11.5955 23.8418 11.1615C23.4078 10.7274 22.7046 10.7274 22.2706 11.1615L17.5007 15.9314L12.7307 11.1615C12.2967 10.7274 11.5935 10.7274 11.1595 11.1615C10.7255 11.5955 10.7255 12.2986 11.1595 12.7326L15.9295 17.5026L11.1595 22.2726C10.7255 22.7066 10.7255 23.4097 11.1595 23.8438C11.3765 24.0608 11.6608 24.1693 11.9451 24.1693C12.2294 24.1693 12.5137 24.0608 12.7307 23.8438L17.5007 19.0738L22.2706 23.8438C22.4876 24.0608 22.7719 24.1693 23.0562 24.1693C23.3405 24.1693 23.6248 24.0608 23.8418 23.8438C24.2758 23.4097 24.2758 22.7066 23.8418 22.2726L19.0718 17.5026Z",
    fill: "#171717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbsent);
export default __webpack_public_path__ + "static/media/absent.e0d020acd92ed242ace005498a56dc82.svg";
export { ForwardRef as ReactComponent };